import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import {SmallUnderline} from "../../styles/components/SmallUnderline";
import {Button} from "../button/Button";
import {BackButton} from "../button/BackButton";
import {BasicAnimation} from "../animations/BasicAnimation";

export class HeroProduct extends Component {

  render() {
    return (

      <div className={"product-hero"}>
        <Container>
          <Row>
            <Col className={"product-hero-content"}
                 xs={{ size: 12 }} md={{ size: 6, offset: 0 }}>
              <BasicAnimation duration={400} delay={0}>
              <BackButton className={"back-button"}> { "< Back" }</BackButton>
              </BasicAnimation>
              <BasicAnimation duration={400} delay={0}>
                <SmallUnderline align="left">
                  <h1>{ this.props.title }</h1>
                </SmallUnderline>
              </BasicAnimation>
              <div className={"product-hero-image-inner"}>
                <BasicAnimation duration={400} delay={0}>
                  <img src={ this.props.image || require('../../assets/images/empty.png')} alt=""/>
                </BasicAnimation>
              </div>
              {
                Boolean(this.props.subtitle) &&
                <div>
                  <BasicAnimation duration={400} delay={100}>
                  <h2>Key Features</h2>
                  <div className={"hero-body"} style={{ ...this.textAlign }}>{ this.props.subtitle }</div>
                  </BasicAnimation>
                </div>
              }
              {
                ( Boolean(this.props.datasheet) || Boolean(this.props.manual) ) &&
                <div>
                  {
                    Boolean(this.props.datasheet) &&
                    <BasicAnimation duration={400} delay={100}>
                      <a href={this.props.datasheet.url} target="_blank" rel="noopener noreferrer">
                        <Button className="download-button datasheet">Download Datasheet (PDF)</Button>
                      </a>
                    </BasicAnimation>
                  }
                  {
                    Boolean(this.props.manual) &&
                    <BasicAnimation duration={400} delay={100}>
                      <a href={this.props.manual.url} target="_blank" rel="noopener noreferrer">
                        <Button className="download-button manual">Download Manual (PDF)</Button>
                      </a>
                    </BasicAnimation>
                  }
                </div>
              }
            </Col>
            <Col className={"product-hero-image"}
                 xs={{ size: 0 }} md={{ size: 6 }} lg={{ size: 6 }}>
              <BasicAnimation duration={400} delay={0}>
                <img src={ this.props.image || require('../../assets/images/empty.png')} alt=""/>
              </BasicAnimation>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/hero/HeroProduct.js